import BaseModelAPI from '../BaseModelAPI';

export default class ProductionControlTime extends BaseModelAPI {
	static entity = 'productioncontroltime';
	static entityName = 'productioncontroltime';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.productionControlTimeDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}